import { RouteRecordRaw } from "vue-router";
import DontLookupPage from "./pages/dont-lookup/DontLookupPage.vue";
import projectTasksRoutes from "project_tasks_section/projectTasksRoutes";
import projectMapRoutes from "project_map_section/routes";

const ProjectsListSection = () => import("projects_list_section/ProjectsListSection");

const projectsRoutes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "projects-list",
    component: ProjectsListSection,
    meta: {
      name: "Список проектов",
    },
  },
  ...projectTasksRoutes,
  ...projectMapRoutes,
  {
    path: ":pathMatch(.*)*",
    component: DontLookupPage,
    meta: {},
  },
];

export default projectsRoutes;
